// extracted by mini-css-extract-plugin
module.exports = {"legal":"LegalMenu_legal__Iuru3"};